import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit,
  Output, QueryList, ViewChildren, ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';

import { Subscription } from 'rxjs';

import {
  CoreModalService, DeviceService, ILink, SdBannerComponent, SdDropdownComponent, SdLinkComponent, SdTitleComponent
} from '@seb/web-design-system/core';

import type { ILoyaltyClub } from './navigation-account.interface';

@Component({
  selector: 'sd-navigation-account',
  templateUrl: './navigation-account.component.html',
  styleUrls: ['./navigation-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgTemplateOutlet,
    SdDropdownComponent,
    SdLinkComponent,
    SdTitleComponent,
    SdBannerComponent
  ]
})
export class SdNavigationAccountComponent implements OnInit, OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef,
    private coreModalService: CoreModalService,
    private deviceService: DeviceService,
    private router: Router,
  ) {}

  isMobile$: boolean;
  mobileSubscription: Subscription;
  buttonSize: number;
  activeLink: string;

  @Input()
  links: ILink[];

  @Input()
  loyaltyClub: ILoyaltyClub;

  @Output()
  clicked = new EventEmitter<string>();

  @ViewChildren('listLink')
  listLink: QueryList<ElementRef>;

  ngOnInit() {
    this.activeLink = this.links.find((link) =>
      this.router.isActive(link.url, false),
    )?.linkName;
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  /**
   * A11y: keyboard navigation
   */
  triggerChild(option: HTMLElement) {
    option.querySelector('a').click();
  }

  linkSelected(linkName: string) {
    this.activeLink = linkName;
    this.clicked.emit(linkName);
    this.coreModalService.closeAllModal();
  }
}
